import {
  Component,
  OnInit,
  Input,
  Output,
  OnChanges,
  EventEmitter
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { popUpActiveAnimation } from "app/shared/animations/popup-center.animation";
import { LocationsService } from "../services/locations/locations.service";

@Component({
  selector: "online-ordering-modal",
  templateUrl: "./online-ordering-modal.component.html",
  styleUrls: ["./online-ordering-modal.component.scss"],
  animations: [popUpActiveAnimation]
})
export class OnlineOrderingModalComponent implements OnChanges {
  @Input() onlineOrderingModalIsActive: boolean;
  public state: string = "inactive";
  @Output() closeOnlineOrderingModal: EventEmitter<any> = new EventEmitter();
  public locations;

  constructor(private _locationsService: LocationsService) {}

  ngOnInit() {
    this._locationsService.getLocations().subscribe(results => {
      this.locations = results["locations"];
      this.locations = this.locations.sort((a, b) => {
        if (a.cityName > b.cityName) {
          return 1;
        }
        if (b.cityName > a.cityName) {
          return -1;
        }
        return 0;
      });
    });
  }

  closeModal(e) {
    if (this.onlineOrderingModalIsActive) {
      this.onlineOrderingModalIsActive = false;
      this.closeOnlineOrderingModal.emit({
        open: this.onlineOrderingModalIsActive
      });
    }
  }

  ngOnChanges(changes) {
    if (changes.onlineOrderingModalIsActive.currentValue === true) {
      this.state = "active";
    } else {
      this.state = "inactive";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/online-ordering-modal/online-ordering.component.ts